import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  TextField,
} from '@material-ui/core';
import FormSubmitButton from '../FormSubmitButton';

class Form extends PureComponent {
  constructor(props) {
    super(props);

    const { user: {
      first_name,
      last_name,
      employee_profile: {
        employee_number,
        identity_number,
      },
      username,
      email,
    } } = props;


    this.state = {
      email,
      username,
      password: '',
      first_name,
      last_name,
      employee_profile_attributes: {
        employee_number,
        identity_number,
      },
      password_confirmation: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleProfileAttributesChange = this.handleProfileAttributesChange.bind(this);
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }

  handleProfileAttributesChange(event) {
    const { name, value } = event.target;
    this.setState({
      employee_profile_attributes: {
        ...this.state.employee_profile_attributes,
        [name]: value,
      },
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const { onSubmit, user } = this.props;
    const { password, password_confirmation } = this.state;

    onSubmit({ employee: {
      ...this.state,
      password: password || null,
      ...(user.id ? { id: user.id } : {}),
      password_confirmation: password_confirmation || null,
    } });
  }

  render() {
    const {
      email,
      password,
      username,
      first_name,
      last_name,
      password_confirmation,
      employee_profile_attributes: {
        employee_number,
        identity_number,
      },
    } = this.state;

    const { editable, passwords, errors } = this.props;

    return (
      <form onSubmit={this.handleSubmit}>
        <Grid container alignItems="center" spacing={32}>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled={!editable}
              fullWidth
              required
              autoFocus
              value={first_name}
              type="text"
              label="Nombre"
              name="first_name"
              error={!!errors.first_name}
              helperText={errors.first_name ? errors.first_name[0] : ''}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled={!editable}
              fullWidth
              required
              value={last_name}
              type="text"
              label="Apellido"
              name="last_name"
              error={!!errors.last_name}
              helperText={errors.last_name ? errors.last_name[0] : ''}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled
              required
              fullWidth
              value={employee_number}
              type="text"
              label="Nro de Funcionario"
              name="employee_number"
              error={!!errors['employee_profile.employee_number']}
              helperText={
                errors['employee_profile.employee_number'] ?
                  errors['employee_profile.employee_number'][0] : ''
              }
              onChange={this.handleProfileAttributesChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled={!editable}
              required
              fullWidth
              value={identity_number}
              type="text"
              label="CI"
              name="identity_number"
              inputProps={{
                maxLength: 8,
                minLength: 8,
              }}
              error={!!errors['employee_profile.identity_number']}
              helperText={
                errors['employee_profile.identity_number'] ?
                  errors['employee_profile.identity_number'][0] : ''
              }
              onChange={this.handleProfileAttributesChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled={!editable}
              required
              fullWidth
              value={username}
              type="text"
              label="Nombre de usuario"
              name="username"
              error={!!errors.username}
              helperText={errors.username ? errors.username[0] : ''}
              onChange={this.handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              disabled={!editable}
              fullWidth
              value={email}
              type="text"
              label="Email"
              name="email"
              error={!!errors.email}
              helperText={errors.email ? errors.email[0] : ''}
              onChange={this.handleChange}
            />
          </Grid>
          { (passwords && editable) && <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              value={password}
              label="Contraseña"
              type="password"
              name="password"
              error={!!errors.password}
              helperText={errors.password ? errors.password[0] : ''}
              onChange={this.handleChange}
            />
          </Grid> }
          { (passwords && editable) && <Grid item xs={12} sm={6}>
            <TextField
              required
              fullWidth
              value={password_confirmation}
              label="Confirmar Contraseña"
              name="password_confirmation"
              type="password"
              error={!!errors.password_confirmation}
              helperText={errors.password_confirmation ? errors.password_confirmation[0] : ''}
              onChange={this.handleChange}
            />
          </Grid> }
          <Grid item xs={12} />
          { editable && <FormSubmitButton /> }
          <Grid item xs={12} />
        </Grid>
      </form>
    );
  }
}

export default Form;

Form.propTypes = {
  user: PropTypes.object,
  editable: PropTypes.bool,
  onSubmit: PropTypes.func,
  passwords: PropTypes.bool,
  errors: PropTypes.object,
};

Form.defaultProps = {
  user: {
    first_name: '',
    last_name: '',
    employee_profile: {
      employee_number: '',
      identity_number: '',
    },
    employee_number: '',
    identity_number: '',
    email: '',
    username: '',
  },
  editable: false,
  onSubmit: () => {},
  passwords: false,
  errors: {},
};



// WEBPACK FOOTER //
// ./src/components/Profile/Form.js